"use client";

import { useEffect } from "react";

import { captureException } from "@/lib/observability/sentry";

/**
 * Route-level error boundary. Per Next.js convention this catches errors in
 * the matching segment subtree. Keep messaging human and quiet — no stack
 * traces in front of the user.
 */
export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error, { digest: error.digest });
  }, [error]);

  return (
    <div className="mx-auto max-w-prose px-6 py-24">
      <h1 className="font-display text-section text-ink">
        Something broke on our end.
      </h1>
      <p className="mt-4 text-body text-muted">
        We logged it. Try again, or come back in a few minutes.
      </p>
      <button type="button" className="btn-primary mt-8" onClick={() => reset()}>
        Try again
      </button>
    </div>
  );
}
